/**
 * Native platform detection helpers.
 *
 * These let shared React components make web-vs-native decisions without
 * importing Capacitor into every file. In a pure web build (yarn build +
 * serve via CRA dev server), `Capacitor.isNativePlatform()` returns false
 * and we keep the existing HTML/axios flows; on a native shell it returns
 * true and we swap in the native plugin.
 */
import { Capacitor } from "@capacitor/core";

/** True iff running inside the compiled iOS or Android app shell. */
export function isNative() {
  return Capacitor.isNativePlatform();
}

/** Convenience: `"ios" | "android" | "web"`. */
export function platform() {
  const p = Capacitor.getPlatform();
  return p === "ios" || p === "android" ? p : "web";
}

/** Format a byte payload size for UX hints. */
export function humanSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
